import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
//import { Router, ActivatedRoute, NavigationStart, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
//import { Http, Response } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/catch';
import { ErrorResponse } from "../../../model/api.model";
import { throws } from "assert";
//import {delay} from "rxjs/operator/delay";
import "rxjs/add/operator/first";
import "rxjs/add/operator/map";
import "rxjs/add/operator/share";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/share";
import "rxjs/add/operator/finally";
import "rxjs/add/operator/share";
import 'rxjs/add/operator/shareReplay';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/operator/delay';
import { Action, Store } from '@ngrx/store';
import * as fromRoot from '../../state/reducer/core.reducer';
import * as coreActions from '../../state/action/core.actions';
import {APP_SETTINGS } from '../../../modules/ng-express-engine/tokens';
import { UtilService } from '../util/util.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { isPlatformBrowser, isPlatformServer} from '@angular/common';

@Injectable()
export class DataService {
    //private routeUrl: string;
    private retry = false;
    private nextPageSubscription;
    private rowsSubscription;
    private apiUrlSeed;
    protected isServer: boolean;

    constructor(
        private http: HttpClient,
        private store: Store<fromRoot.State>,
        private utils: UtilService,
        @Inject(APP_SETTINGS) private settings: Object,
        private oauthService: OAuthService,
        @Inject(PLATFORM_ID) private platformId: string,
    ) { 
        this.isServer = isPlatformServer(this.platformId);
        this.apiUrlSeed = settings['DATA_API_ENDPOINT'];
    }

    getDataWithPathElement(element: string, apiUrl: string) {
        apiUrl += "/" + element;
        return this.getData({}, apiUrl, 0, false, true, false);
    }

    buildQueryString(paramDictionary: Object){
        let res = '?';
        Object.keys(paramDictionary)
        .forEach(function(key) {
            res = res + key + '=' + paramDictionary[key]; + "&";
          });
          return res;
    }

    getDataWithQueryString(apiUrl: string, paramDictionary: Object){
        apiUrl = apiUrl + this.buildQueryString(paramDictionary);
        return this.getData({}, apiUrl, 0, true, true, false);
    }

    getRouterData(routeParams: Object, routeUrl: string, dispatch?: boolean) {
        //this.routeUrl = routeUrl;
        dispatch = (dispatch !== undefined) ? dispatch : true;
        if (routeUrl){
            return this.getData(routeParams, routeUrl, 0, dispatch, true, false);
        }   
        else{
            return Observable.of(null);
        }
    }

    private processDeleteResult(res: Object, dispatch?: boolean, dipatchKey?: string){
        if (dispatch && dipatchKey) {
            this.store.dispatch(new coreActions.LoadDataItemSuccessAction({ dataContent: res, isSlug: true, apiUrl: dipatchKey }));
        }
        return res;
    }

    deleteData (apiUrl: string, id: string, customHeaders?: object, dispatch?: boolean, dispatchKey?: string, numRetries?: number){
        const headers = this.attachHeaders(customHeaders);
        
        let finalUrl = this.prepareUrl(apiUrl);
        //apiUrl = 'https://699439d0.ngrok.io/favorites';
        finalUrl = finalUrl + "/" + id; 
        numRetries = (typeof numRetries == 'undefined') ? 0 : numRetries;
        
        return this.http.delete(finalUrl, {headers})
            .map(res => this.processDeleteResult(res, dispatch, dispatchKey))
            .catch((err: any): any => {
                let httpResponseStatus;
                let retry = false;
                //console.log(err.message);
                httpResponseStatus = err["status"];
                //console.log(httpResponseStatus);
                if (httpResponseStatus != null) {
                    if (httpResponseStatus > 499 || httpResponseStatus == 408) {
                        retry = true;
                    }
                }
                else {
                    httpResponseStatus = -1;
                }
                if (retry && numRetries < 3) {
                    return this.deleteData(apiUrl, id, customHeaders,  dispatch, dispatchKey, ++numRetries).delay(numRetries * 500);
                }
                else {
                    return this.returnError(httpResponseStatus);
                }
            })
            .finally(() => {
                //console.log('After the request...');
            });            
    }

    private processPutResult(res: Object, dispatch?: boolean, dipatchKey?: string){
        if (dispatch && dipatchKey) {
            this.store.dispatch(new coreActions.LoadDataItemSuccessAction({ dataContent: res, isSlug: true, apiUrl: dipatchKey }));
        }
        return res;
    }

    putData (apiUrl: string, data: any, customHeaders?: object, dispatch?: boolean, dispatchKey?: string, numRetries?: number){
        const headers = this.attachHeaders(customHeaders);
        const finalUrl = this.prepareUrl(apiUrl);
        numRetries = (typeof numRetries == 'undefined') ? 0 : numRetries;
        return this.http.put(finalUrl, data, {headers})
            .map(res => this.processPutResult(res, dispatch, dispatchKey))
            .catch((err: any): any => {
                let httpResponseStatus;
                let retry = false;
                //console.log(err.message);
                httpResponseStatus = err["status"];
                const errMessage = err['error']['errors'];
                //console.log(httpResponseStatus);
                if (httpResponseStatus != null) {
                    if (httpResponseStatus > 499 || httpResponseStatus == 408) {
                        retry = true;
                    }
                }
                else {
                    httpResponseStatus = -1;
                }
                if (retry && numRetries < 3) {
                    return this.putData(apiUrl, data, customHeaders,  dispatch, dispatchKey, ++numRetries).delay(numRetries * 500);
                }
                else {
                    return this.returnError(httpResponseStatus, errMessage);
                }
            })
            .finally(() => {
                //console.log('After the request...');
            });            
    }

    private processPatchResult(res: Object, dispatch?: boolean, dipatchKey?: string){
        if (dispatch && dipatchKey) {
            this.store.dispatch(new coreActions.LoadDataItemSuccessAction({ dataContent: res, isSlug: true, apiUrl: dipatchKey }));
        }
        return res;
    }

    patchData (apiUrl: string, data: any, customHeaders?: object, dispatch?: boolean, dispatchKey?: string, numRetries?: number){
        const headers = this.attachHeaders(customHeaders);
        let finalUrl = this.prepareUrl(apiUrl);
        //finalUrl = 'https://542a89c3.ngrok.io/users/profile';
        numRetries = (typeof numRetries == 'undefined') ? 0 : numRetries;
        return this.http.patch(finalUrl, data, {headers})
            .map(res => this.processPatchResult(res, dispatch, dispatchKey))
            .catch((err: any): any => {
                let httpResponseStatus;
                let retry = false;
                //console.log(err.message);
                httpResponseStatus = err["status"];
                const errMessage = err['error']['errors'];
                //console.log(httpResponseStatus);
                if (httpResponseStatus != null) {
                    if (httpResponseStatus > 499 || httpResponseStatus == 408) {
                        retry = true;
                    }
                }
                else {
                    httpResponseStatus = -1;
                }
                if (retry && numRetries < 3) {
                    return this.patchData(apiUrl, data, customHeaders,  dispatch, dispatchKey, ++numRetries).delay(numRetries * 500);
                }
                else {
                    return this.returnError(httpResponseStatus, errMessage);
                }
            })
            .finally(() => {
                //console.log('After the request...');
            });            
    }

    private processPostResult(res: Object, dispatch?: boolean, dipatchKey?: string){
        if (dispatch && dipatchKey) {
            this.store.dispatch(new coreActions.LoadDataItemSuccessAction({ dataContent: res, isSlug: true, apiUrl: dipatchKey }));
        }
        return res;
    }

    postData (apiUrl: string, data: any, customHeaders?: object, dispatch?: boolean, dispatchKey?: string, numRetries?: number){
        const headers = this.attachHeaders(customHeaders);
        //apiUrl = 'https://699439d0.ngrok.io/favorites';
        const finalUrl = this.prepareUrl(apiUrl);
        numRetries = (typeof numRetries == 'undefined') ? 0 : numRetries;
        return this.http.post(finalUrl, data, {headers})
            .map(res => this.processPostResult(res, dispatch, dispatchKey))
            .catch((err: any): any => {
                let httpResponseStatus;
                let retry = false;
                //console.log(err.message);
                httpResponseStatus = err["status"];
                //console.log(httpResponseStatus);
                if (httpResponseStatus != null) {
                    if (httpResponseStatus > 499 || httpResponseStatus == 408) {
                        retry = true;
                    }
                }
                else {
                    httpResponseStatus = -1;
                }
                if (retry && numRetries < 3) {
                    return this.postData(apiUrl, data, customHeaders,  dispatch, dispatchKey, ++numRetries).delay(numRetries * 500);
                }
                else {
                    return this.returnError(httpResponseStatus);
                }
            })
            .finally(() => {
                //console.log('After the request...');
            });            
    }

    private returnError(httpResponseStatus: number, errorMessage?: any){
        var errResponse = <ErrorResponse>{ "has_error": true, "error_status": httpResponseStatus, error: errorMessage ? {error: errorMessage }  : {error: "error" }};
        return Observable.of(errResponse);
    }

    private attachHeaders(customHeaders?: object){
        //if(!this.isServer ){
        //    window["device"] = {};
        //    window["device"]["model"] = "The Stick"; //android.deviceModel();
        //    window["device"]["version"] = "12345"; //android.deviceVersion();
        //    window["device"]["platform"] = "fire TV"; //android.devicePlatform();
        //    window["device"]["uuidString"] = "hello-is-my-id"; //android.deviceUuidString();
        //    window["device"]["name"] = "hello-is-my-name"; //android.deviceName();   
        //}
        let headers = new HttpHeaders();
        const self = this;
        if (this.settings['API_HEADERS']){
            const headerInfo = this.settings['API_HEADERS'];
            Object.keys(headerInfo).forEach(function(key) {
                if (headerInfo[key].indexOf('^^') < 0){
                    headers = headers.set(key, headerInfo[key])
                }
                else{
                    if (!self.isServer){
                        const valSplit = headerInfo[key].split('^^');
                        const target = window[valSplit.shift()]
                        const value = valSplit.map(val => target[val]).join("-")
                        //const val = window[valSplit[0]][valSplit[1]];
                        if (value) {
                            headers = headers.set(key, value);
                        }
                    }
                }
            });
            if(!this.isServer )
            {
                if (this.oauthService.hasValidAccessToken()){
                    headers = headers.set("Authorization", "Bearer " + this.oauthService.getAccessToken());
                }  
            }
        }
        if (customHeaders){
            Object.keys(customHeaders).forEach(function(key) {
                headers = headers.set(key, customHeaders[key])
            });
        }
        return headers;
    }

    private prepareUrl(apiUrl){
        // apiUrl = apiUrl.slice(0, apiUrl.indexOf("?") - 1);
        if (apiUrl.indexOf("http") < 0) {
            let apiUrlRegex = /(^[\/\w\-%]+)(#.*)?/;
            let apiUrlMatches = apiUrl.match(apiUrlRegex);

            if(apiUrlMatches)
            {
                apiUrl = apiUrlMatches[1];
            }
            else
            {
                apiUrl = "/";
            }

            if(apiUrl == "/" || apiUrl == "")
            {
                apiUrl = this.apiUrlSeed + this.settings['HOME_ROUTE'];
            }
            else if(apiUrl.indexOf('/embed/') !== -1)
            {
                apiUrl = this.apiUrlSeed + apiUrl.replace('/embed/', '/');
            }
            else
            {
                apiUrl = this.apiUrlSeed + apiUrl;
            }
        }
        apiUrl = (apiUrl.indexOf('/switch') > -1) ? apiUrl.replace('/switch','') : apiUrl;
        return apiUrl;

    }

    getFreshData(apiUrl:string): Observable<any>{
        const headers = this.attachHeaders();
        apiUrl = this.prepareUrl(apiUrl);

        return this.http.get(apiUrl, {headers})
            .map(res => this.processData(res, apiUrl, true, false, false));
    };

    getData(routeParams: Object, apiUrl: string, numRetries?: number, dispatch?: boolean, isSlug?: boolean, asyncChildren?: boolean): Observable<any> {

        const headers = this.attachHeaders();
        asyncChildren = (asyncChildren == null) ? false : asyncChildren;
        this.retry = false;
        //console.log('before');
        //console.log(apiUrl);
//         apiUrl = apiUrl.replace("//", "/");
//         if (apiUrl.indexOf('/tags') > -1){
//             if (apiUrl.indexOf("http") < 0){
//                 apiUrl = this.apiUrlSeed + apiUrl;
//             }
//         }

        let finalUrl = this.prepareUrl(apiUrl);
        //console.log('after');
        //console.log(apiUrl);
        numRetries = (typeof numRetries == 'undefined') ? 0 : numRetries;
        dispatch = (dispatch) ? dispatch : false;
        isSlug = (isSlug == null) ? false : isSlug;

        return this.http.get(finalUrl, {headers})
            .map(res => this.processData(res, finalUrl, dispatch, isSlug, asyncChildren))
            .shareReplay()
            .catch((err: any): any => {
                let httpResponseStatus;
                let retry = false;
                //console.log(err.message);
                httpResponseStatus = err["status"];
                //console.log(httpResponseStatus);
                //console.log("httpResponseStatus");
                if (httpResponseStatus != null) {
                    if (httpResponseStatus > 499 || httpResponseStatus == 408) {
                        retry = true;
                    }
                }
                else {
                    httpResponseStatus = -1;
                }
                //console.log("httpResponseStatus2");
                if (retry && numRetries < 3) {
                    //console.log("httpResponseStatus21");
                    return this.getData(routeParams, apiUrl, ++numRetries, dispatch, isSlug, asyncChildren).delay(numRetries * 500);
                }
                else {
                    return this.returnError(httpResponseStatus);
                }
            })
            .finally(() => {
                //console.log('After the request...');
            });
    }

    private shouldRetry(err: any): boolean {

        if (err instanceof Response) {
            let responseErr = err as Response;
            let responseStatus = responseErr.status;
            if (responseStatus === 408 || responseStatus > 499) {
                this.retry = true;
                return true;
            }
            else {
                this.retry = false;
                return false;
            }
        }
        this.retry = false;
        return false;
    }

    //     private processDataWithDispatch(res: Object, key: string){
    // 
    //         //console.log("processing");
    //         //let result = this.routeBuild(res);
    //         const result = res;
    //         result["has_error"] = false;
    //         result["error_status"] = 0;
    //         this.store.dispatch(new coreActions.LoadDataItemSuccessAction({ dataContent: result }));
    //         return result;
    //     }

    private processData(res: Object, key: string, dispatch: boolean, isSlug?: boolean, asyncChildren?: boolean) {
        //var t00 = performance.now();
        //console.log("processing");
        let bucket = [];
        asyncChildren = (asyncChildren == null) ? false : asyncChildren;
        //asyncChildren = true;
        if (asyncChildren) {
            if (res['rows'] && Array.isArray(res['rows'])){
                const asyncRows = res['rows'].filter(row => row['data'] == null || row['data'].length == 0);
                for (let row of asyncRows) {
                    if (row["get_url"]){
                        bucket.push(this.getData({}, row["get_url"].replace(this.apiUrlSeed, ""), 0, true, true, false));
                    }
                }
                if (bucket.length > 0) {
                    if (this.rowsSubscription){
                        this.rowsSubscription.unsubscribe();
                    }
                    this.rowsSubscription = Observable.forkJoin(bucket).subscribe();
                }
            }
            else{
//                 if (res['meta']['next_page_url'] && (res['meta']['next_page_url'].indexOf('page=2') > -1)){
//                     let nextPageSubscription = this.getData({}, res['meta']['next_page_url'].replace(this.apiUrlSeed, ""), 0, true, true, false).subscribe();
//                 }
            }
        }
        //var t01 = performance.now();
        //console.log("async kids took " + (t01 - t00) + " milliseconds.");
        isSlug = (isSlug == null) ? false : isSlug;
        key = key.replace(this.apiUrlSeed, "");
        if (!res['get_url']){
            res['get_url'] = key;
        }
        if (res['meta'] && res['meta']['next_page_url'] && (res['meta']['next_page_url'].indexOf('page=2') > -1)){
            if (this.nextPageSubscription){
                this.nextPageSubscription.unsubscribe();
            }
            const npUrl = res['meta']['next_page_url'].replace("//", "/");
            this.nextPageSubscription = this.getData({}, res['meta']['next_page_url'], 0, true, true, false).subscribe();
        }
        //var t02 = performance.now();
        //console.log("next page took " + (t02 - t01) + " milliseconds.");
        const result = this.buildInternalRoutes(res, key);
        //var t03 = performance.now();
        //console.log("route build took " + (t03 - t02) + " milliseconds.");
        //const result2 = this.routeBuild(res);
        //const rows =  
        if (result['meta']  && !result['meta']['slug']){
            result['meta']['slug'] = key.replace(new RegExp('/', 'g'), "_").toLowerCase();
        }
        result["asyncBucket"] = bucket;
        result["has_error"] = false;
        result["error_status"] = 0;
        //const self = this;
        if (dispatch) {
            //const dispatchAsync = setTimeout(function(){ self.store.dispatch(new coreActions.LoadDataItemSuccessAction({ dataContent: result, isSlug: isSlug, apiUrl: key })); }, 500);
            this.store.dispatch(new coreActions.LoadDataItemSuccessAction({ dataContent: result, isSlug: isSlug, apiUrl: key }));
        }
        //var t04 = performance.now();
        //console.log("dispatch action took " + (t04 - t03) + " milliseconds.");
        //console.log("total " + (t04 - t00) + " milliseconds.");
        return result;
    }

    getAddressData(address: string) {
        return this.http.get(address);
    }

    private buildInternalRoutes(sourceObject: Object, key: string): Object {
        if (sourceObject == null){
            return;
        }
        const jsonObject = Object.assign({}, sourceObject);
        const objectKeys = Object.keys(jsonObject);
        const allowedPres = this.settings['ROUTE_TRANSLATION_MAP'];
        for (let objectKey of objectKeys){
            if (jsonObject[objectKey] == '[]'){
                jsonObject[objectKey] = [];
            }
            if (Array.isArray(jsonObject[objectKey])){
                let arrayResult = [];
                for (let arrayItem of jsonObject[objectKey]){
                    arrayResult.push(this.buildInternalRoutes(arrayItem, key));
                }
                jsonObject[objectKey] =[].concat(arrayResult);
            }
            else{
                if (jsonObject[objectKey] !== null && typeof jsonObject[objectKey] === 'object'){
                    jsonObject[objectKey] = this.buildInternalRoutes(jsonObject[objectKey], key);
                }
                else{
                    if (typeof jsonObject[objectKey] === 'string' && jsonObject[objectKey]){
                        for (let pre of allowedPres){
                            if ((pre + '_url') == objectKey){
                                if (jsonObject['internal_route'] == null){
                                    jsonObject['internal_route'] = jsonObject[objectKey].replace(this.apiUrlSeed, "");

                                    //if (key.indexOf('home') > -1 && jsonObject['obj_type'] == 'Stream'){
                                    //    jsonObject['url'] =  jsonObject['internal_route'];
                                    //}
                                }
                            }
                        }
                    }
                }
            }
        }

        return jsonObject;
    }

    public routeBuild(sourceObject: Object): Object {

        if (sourceObject == null){
            return;
        }
        const jsonObject = JSON.parse(JSON.stringify(sourceObject));
        if (jsonObject["rows"] != null){
            if (Array.isArray(jsonObject["rows"])){
                jsonObject["rows"] = jsonObject["rows"].filter(row => row != null);
            }
        }
        try{
            const dataRows: Array<Object> = jsonObject["rows"];
            let dataItems: Array<Object>;
            const metadata = jsonObject["meta"];
            if (metadata != null) {
                this.routeBuildForItem(metadata);
            }
            if (dataRows == null) {
                dataItems = jsonObject["data"];
                if (dataItems == null) {
                    dataItems = [];
                }
                for (let dataItem of dataItems) {
                    this.routeBuildForItem(dataItem);
                }
            }
            else {
                for (let row of dataRows) {
                    if (row != null){
                        this.routeBuildForItem(row);
                        dataItems = row["data"];
                        if (dataItems!=null){
                            for (let dataItem of dataItems) {
                                this.routeBuildForItem(dataItem);
                            }
                        }
                    }
                }
            }
        }
        catch(ex){
            //console.log(ex.message);
            //console.log(jsonObject);
        }
        return jsonObject;
    }

    private processUrl(source: Object) {
        let res = [];
        for (let key of Object.keys(source)) {
            res.push({ route_type: key.split("_")[0] + "_route", route: source[key].replace(this.apiUrlSeed, "") });
        }

        return res;
    }

    private filterByPattern(source: Object, pattern: string): Object {
        const copySource = Object.assign({}, source);
        Object.keys(source)
            .filter(key => key.indexOf(pattern) < 0)
            .forEach(key => delete copySource[key]);

        return copySource;
    }

    private getKey(source: Object, pattern: string){
        for (let key of Object.keys(source)){
            if (key.indexOf(pattern) > -1){
                return key;
            }
        }
        return null;
    }
    


    private routeBuildForItemNonRecursive(dataItem: Object): void {
        if (dataItem == null){
            return;
        }
        let item = dataItem;
        if(dataItem["meta"] != null)
        {
             this.routeBuildForItem(dataItem["meta"]);
        }
        if (item["internal_route"] == null) {
            const key = this.getKey(item, "_url");
            if(key !=null && item[key] != null){
                item["internal_route"] = item[key].replace(this.apiUrlSeed, "");
            } 
        }
    }

    private routeBuildForItem(dataItem: Object): void {
        this.routeBuildForItemNonRecursive(dataItem);
        
        try{
            const itemKeys = Object.keys(dataItem);
            for (let itemKey of itemKeys){
                if (dataItem[itemKey] !== null && typeof dataItem[itemKey] === 'object'){
                    if (Array.isArray(dataItem[itemKey])){
                        for (let arrItem of dataItem[itemKey]){
                            if (arrItem !== null && typeof arrItem === 'object'){
                                if (arrItem != null){
                                    this.routeBuildForItem(arrItem);
                                }                             
                            }
                        }
                    }
                    else{
                        if (dataItem[itemKey] != null){
                            this.routeBuildForItem(dataItem[itemKey]);
                        }                      
                    }
                    
                }
            }
        }
        catch(ex){
            console.log(ex.message);
            //console.log(dataItem);
        }

    }

}



// WEBPACK FOOTER //
// ./src/angular-engine/engine/service/data/api.data.service.ts